export default class Constants {
  static BasePageSegment = 'documents';
  static BasePagePath = `/${Constants.BasePageSegment}`;
  static DefaultDocumentTypesParam = 'documentTypes';
  static DefaultContractsParam = 'contracts';
  static DefaultPeriodParam = 'year';
  static DefaultKeywordParam = 'keyword';
}
